import classnames from 'classnames'
import styles from './DebugMobileText.module.scss'
import useStore from '@/store'

const DebugMobileText = ({ className }) => {
  const debugMobileText = useStore(state => state.debugMobileText)
  // if (process.env.NODE_ENV === 'production' || !debugMobileText) return null
  if (!debugMobileText) return null

  return (
    <div className={classnames(styles.DebugMobileText, className)}>
      <span
        className={styles.text}
        dangerouslySetInnerHTML={{ __html: debugMobileText }}
      />
    </div>
  )
}

DebugMobileText.displayName = 'DebugMobileText'

export default DebugMobileText
